// Needed to use 2 template types because only one can produce result,
// used 2 so that it is clear from the service call which will have the data Results? or Data?.
export class QueryHandlerResponse<DataType, ResultType> {
    StatusCode: number;
    ErrorMessage: string | null;
    Data: DataType | null; // used for graphql
    Results: ResultType | null; // used for backend mostly
    TotalCount: number | null;
}
